"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Price = _interopRequireDefault(require("../Price"));
var _Label = _interopRequireDefault(require("../Label"));
var _constant = require("./constant");
var _PriceSlashWithDiscount = _interopRequireDefault(require("./PriceSlashWithDiscount.proptypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var DiscountPriceWrapper = _styledComponents.default.div.withConfig({
  displayName: "PriceSlashWithDiscount__DiscountPriceWrapper",
  componentId: "sc-1nk6wt3-0"
})(function (_ref) {
  var isInline = _ref.isInline,
    alignment = _ref.alignment;
  return "\n    display: flex;\n    flex-direction: ".concat(isInline ? 'row' : 'column', ";\n    align-items: ").concat(alignment, ";\n    justify-content: flex-end;\n    margin-right: 4px;\n    ");
});
var PercentageDiscountWrapper = _styledComponents.default.div.withConfig({
  displayName: "PriceSlashWithDiscount__PercentageDiscountWrapper",
  componentId: "sc-1nk6wt3-1"
})(["padding-left:", ";font-family:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.space.micro);
}, function (_ref3) {
  var theme = _ref3.theme;
  return "".concat(theme.fontFamily.default, ", Roboto");
});
var DiscountPercentageWrapper = _styledComponents.default.div.withConfig({
  displayName: "PriceSlashWithDiscount__DiscountPercentageWrapper",
  componentId: "sc-1nk6wt3-2"
})(["display:inline-block;"]);
var PriceSlashWithDiscount = function PriceSlashWithDiscount(props) {
  var accessible = props.accessible,
    theme = props.theme,
    translation = props.translation,
    currency = props.currency,
    isInline = props.isInline,
    alignment = props.alignment,
    discountInfo = props.discountInfo;
  var _ref4 = discountInfo || {},
    _ref4$strikethroughPr = _ref4.strikethroughPrice,
    strikethroughPrice = _ref4$strikethroughPr === void 0 ? null : _ref4$strikethroughPr,
    _ref4$showCurrency = _ref4.showCurrency,
    showCurrency = _ref4$showCurrency === void 0 ? true : _ref4$showCurrency,
    _ref4$promoLabel = _ref4.promoLabel,
    promoLabel = _ref4$promoLabel === void 0 ? '' : _ref4$promoLabel,
    _ref4$percentageOff = _ref4.percentageOff,
    percentageOff = _ref4$percentageOff === void 0 ? null : _ref4$percentageOff;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var language = _objectSpread(_objectSpread({}, _constant.TRANSLATION), translation);
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, strikethroughPrice && /*#__PURE__*/_react.default.createElement(DiscountPriceWrapper, {
      isInline: isInline,
      alignment: alignment
    }, /*#__PURE__*/_react.default.createElement(PercentageDiscountWrapper, null, /*#__PURE__*/_react.default.createElement(_Price.default, {
      accessible: accessible,
      amount: strikethroughPrice && strikethroughPrice,
      color: "greyDark",
      hideCurrency: !showCurrency,
      currency: currency || 'MYR',
      strikethrough: true,
      theme: theme,
      customFontSize: "textSmall",
      customCurrencySize: "titleSmall",
      priceTemplate: "TEMPLATE3",
      decimalType: "CEIL",
      noDecimalValues: true,
      defaultIDRLocale: false
    })), /*#__PURE__*/_react.default.createElement(PercentageDiscountWrapper, null, promoLabel > 0 && /*#__PURE__*/_react.default.createElement(_Label.default, {
      accessible: true,
      labelColor: "greenLight",
      textColor: "tertiaryDark",
      theme: theme
    }, /*#__PURE__*/_react.default.createElement(_Price.default, {
      accessible: accessible,
      amount: promoLabel && promoLabel,
      color: "tertiaryDark",
      hideCurrency: !showCurrency,
      currency: currency || 'MYR',
      theme: theme,
      customFontSize: "textSmall",
      customCurrencySize: "titleSmall",
      priceTemplate: "TEMPLATE3",
      decimalType: "CEIL",
      noDecimalValues: true,
      defaultIDRLocale: false
    }), ' ', language.off), percentageOff > 0 && /*#__PURE__*/_react.default.createElement(DiscountPercentageWrapper, null, /*#__PURE__*/_react.default.createElement(_Label.default, {
      accessible: true,
      labelColor: "primaryLight",
      textColor: "primary",
      theme: theme
    }, percentageOff, '%', " ", language.off)))));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
PriceSlashWithDiscount.propTypes = _PriceSlashWithDiscount.default.PropTypes;
PriceSlashWithDiscount.defaultProps = _PriceSlashWithDiscount.default.DefaultProps;
var _default = PriceSlashWithDiscount;
exports.default = _default;